import { useCallback } from 'react';
import { useAsyncFunction } from '../../utils/hooks/useAsyncFunction';
import { useHttpClient } from '../../client/HttpClientContext';
import { taskSettingsCache } from '../../cache';
export const useTaskSettings = ({
  skip
}) => {
  const httpClient = useHttpClient();
  const getTaskSettings = useCallback(() => {
    return taskSettingsCache.get('taskSettings', httpClient);
  }, [httpClient]);
  return useAsyncFunction(getTaskSettings, {
    skip
  });
};